/**
 * PROFILE ACTIONS
 */
export const PROFILE_FETCH = 'profileFetch'
export const PROFILE_METRICS_FETCH = 'profileMetricsFetch'
export const NOTIFICATIONS_FETCH = 'notificationsFetch'
